import { i18n } from '../../../i18n-handler/handler/i18n';
import { IFiltersList } from '../../../interfaces/filters/IFiltersList';

let lang = 'fr';

function getStatusFilterList(): IFiltersList[] {
    return [
        { value: '', label: i18n.t('mission.filters.all', { lng: lang }) },
        { value: 'waiting', label: i18n.t('mission.filters.waiting', { lng: lang }) },
        { value: 'booked', label: i18n.t('mission.filters.booked', { lng: lang }) },
        { value: 'cancelled', label: i18n.t('mission.filters.cancelled', { lng: lang }) },
    ];
}

export type ExtraReturn = {
    getStatusFilterList: Function;
};

export const extra = (_lang: string): ExtraReturn => {
    lang = _lang;
    return {
        getStatusFilterList,
    };
};
